// extracted by mini-css-extract-plugin
module.exports = {"card":"ServiceCard_card__30izK","overlay":"ServiceCard_overlay__3OCKr","img":"ServiceCard_img__raepY","text":"ServiceCard_text__8uZmw"};